import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=33d7224f&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=ts"
export * from "./Publications.vue?vue&type=script&lang=ts"
import style0 from "./Publications.vue?vue&type=style&index=0&id=33d7224f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d7224f",
  null
  
)

export default component.exports